import { useState } from "react";
import { scheduleServiceFetch } from "../../../../../utils/constants/callService";
import { downloadBlob } from "../../../../../utils/methods/downloadFiles";
import { Types } from "../../../../../utils/enums"
import { Evidence } from "../../../../../service/reportFolio/response"

export const useEvidenceDownload = (title: string, evidences?: Evidence[]) => {

    const [disable, setDisable] = useState<boolean>(false);
    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.ERROR as string,
    });

    const handleCloseSnackbar = (value: boolean) => setOpenSnackbar({ ...openSnackbar, open: value });

    const evidenceMethod = () => {
        return {
            evidences: evidences?.filter(item => !item.comments || (item.comments && !!item.comments?.length)),
        };
    };

    const downloadEvidences = async () => {
        setDisable(true);

        const newEvidences = evidenceMethod();

        const responseTemplate = await scheduleServiceFetch.downloadEvidences(newEvidences);
        const blob = await responseTemplate.blob();

        if (blob.type !== 'application/zip') {
            setOpenSnackbar(prev => ({
                ...prev,
                open: true,
                message: 'Ocurrió un error al descargar las evidencias',
            }));
        } else {
            downloadBlob(blob, title);
        }

        setDisable(false);
    };

    return {
        disable,
        openSnackbar,
        handleCloseSnackbar,
        downloadEvidences,
    };
};